import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "configuration-settings" }
const _hoisted_2 = { class: "d-flex gap-3 mt-4" }

import { ref, computed, onMounted } from 'vue'
import { api } from '@/composables/api'

// Configuration State

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigurationSettings',
  setup(__props) {

const config = ref({
  registration: 'requireApproval',
  allowed_domains: [] as string[]
})

const originalConfig = ref({})
const saving = ref(false)
const loading = ref(false)
const successMessage = ref('')
const errorMessage = ref('')

const registrationOptions = [
  { title: 'Open Registration - Anyone can create an account', value: 'open' },
  { title: 'Require Approval - Admin must approve new accounts', value: 'requireApproval' },
  { title: 'Disabled - Only admin can create accounts', value: 'none' }
]

const hasChanges = computed(() => {
  return JSON.stringify(config.value) !== JSON.stringify(originalConfig.value)
})

// Clean up domain entries (remove @ symbols, whitespace, etc.)
const cleanDomains = (domains: string[]) => {
  config.value.allowed_domains = domains
    .map(d => d.replace(/^@/, '').trim().toLowerCase())
    .filter(d => d.length > 0 && d.includes('.'))
}

// Load configuration
const loadConfig = async () => {
  loading.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    const response = await api.get('/configuration')
    const data = response.data

    config.value = {
      registration: data.registration || 'requireApproval',
      allowed_domains: data.allowed_domains || []
    }

    originalConfig.value = JSON.parse(JSON.stringify(config.value))
  } catch (error: any) {
    console.error('Error loading config:', error)
    errorMessage.value = 'Failed to load configuration'
  } finally {
    loading.value = false
  }
}

// Save configuration
const saveConfig = async () => {
  saving.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    await api.put('/configuration', config.value)

    originalConfig.value = JSON.parse(JSON.stringify(config.value))
    successMessage.value = 'Configuration saved successfully!'
  } catch (error: any) {
    console.error('Error saving config:', error)
    errorMessage.value = error.response?.data?.detail || 'Failed to save configuration'
  } finally {
    saving.value = false
  }
}

onMounted(() => {
  loadConfig()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "mb-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-cog", -1)
              ]))]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createTextVNode(" Registration Settings ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_alert, {
              type: "info",
              variant: "tonal",
              class: "mb-6"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("strong", null, "Registration Configuration", -1),
                _createElementVNode("p", { class: "text-caption mb-0 mt-2" }, " Configure how users can register for the portal, including allowed email domains. ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_form, {
              ref: "configForm",
              onSubmit: _withModifiers(saveConfig, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: config.value.registration,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((config.value.registration) = $event)),
                          items: registrationOptions,
                          "item-title": "title",
                          "item-value": "value",
                          label: "Registration Mode",
                          variant: "outlined",
                          density: "comfortable",
                          hint: "Controls how new users can register",
                          "persistent-hint": "",
                          disabled: saving.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_combobox, {
                          modelValue: config.value.allowed_domains,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((config.value.allowed_domains) = $event)),
                            cleanDomains
                          ],
                          items: [],
                          label: "Allowed Email Domains",
                          variant: "outlined",
                          density: "comfortable",
                          multiple: "",
                          chips: "",
                          "closable-chips": "",
                          hint: "Email domains allowed for signup (e.g., 'brevardschools.org'). Leave empty to allow all domains.",
                          "persistent-hint": "",
                          disabled: saving.value
                        }, {
                          chip: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_chip, _mergeProps(props, {
                              color: "primary",
                              variant: "outlined"
                            }), {
                              default: _withCtx(() => [
                                _createTextVNode(" @" + _toDisplayString(item.value), 1)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          "no-data": _withCtx(() => [
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createTextVNode(" Type a domain (without @) and press ", -1),
                                    _createElementVNode("kbd", null, "Enter", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    (config.value.allowed_domains && config.value.allowed_domains.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_alert, {
                              type: "info",
                              variant: "tonal",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Allowed signup emails:", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.allowed_domains, (domain, index) => {
                                  return (_openBlock(), _createElementBlock("span", { key: domain }, _toDisplayString(index > 0 ? ', ' : '') + "*@" + _toDisplayString(domain), 1))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_alert, {
                              type: "warning",
                              variant: "tonal",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("strong", null, "Warning:", -1),
                                _createTextVNode(" No domain restrictions set. Anyone with any email address can sign up. ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    type: "submit",
                    loading: saving.value,
                    disabled: !hasChanges.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-content-save", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode(" Save Configuration ", -1))
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  _createVNode(_component_v_btn, {
                    color: "grey",
                    variant: "outlined",
                    onClick: loadConfig,
                    disabled: saving.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("mdi-refresh", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createTextVNode(" Reset ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }, 512),
            (successMessage.value)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "success",
                  variant: "tonal",
                  closable: "",
                  "onClick:close": _cache[2] || (_cache[2] = ($event: any) => (successMessage.value = '')),
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(successMessage.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (errorMessage.value)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 1,
                  type: "error",
                  variant: "tonal",
                  closable: "",
                  "onClick:close": _cache[3] || (_cache[3] = ($event: any) => (errorMessage.value = '')),
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(errorMessage.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})